interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - currentPage) <= 1) {
      pages.push(i);
    }
  }

  const items: (number | "ellipsis")[] = [];
  let prev = 0;
  pages.forEach((p) => {
    if (prev && p - prev > 1) items.push("ellipsis");
    items.push(p);
    prev = p;
  });

  const btnBase =
    "flex h-9 min-w-9 cursor-pointer items-center justify-center rounded-md px-2 text-sm transition-colors";

  return (
    <nav className="flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className={`${btnBase} border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-left-s-line" />
        </span>
        上一页
      </button>

      {items.map((item, idx) =>
        item === "ellipsis" ? (
          <span key={`e-${idx}`} className="px-1 text-foreground-400">
            …
          </span>
        ) : (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`${btnBase} ${
              item === currentPage
                ? "bg-primary-500 text-background-50"
                : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {item}
          </button>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        className={`${btnBase} border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        下一页
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-right-s-line" />
        </span>
      </button>
    </nav>
  );
}